import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TextField, Typography, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import fetchIntegrationXML from '../fetchIntegrationXML';

const XMLDiv = styled.div`
    margin-top: 24px;
`;
const DetailsDiv = styled.div`
    display: flex;
    flex-direction: column;
`;
const ButtonsDiv = styled.div`
    display: flex;
    margin-top: 10px;
`;

const CopyButton = styled(Button)`
    margin-left: 12px;
`;

interface XMLViewProps {
    title: string;
}

const XMLView: React.FC<XMLViewProps> = ({ title }) => {
    const { t } = useTranslation('admin_settings');
    const xml = fetchIntegrationXML();

    const CopyXMLButton = () => {
        const copyXML = () => {
            navigator.clipboard.writeText(xml);
        };
        return (
            <CopyButton
                onClick={copyXML}
                variant='outlined'
            >
                {t('copy')}
            </CopyButton>
        );
    };

    const DownloadButton: React.FC = () => {
        const StyledDownloadButton = styled(Button)`
            margin-left: 12px;
        `;

        const downloadXML = () => {
            const element = document.createElement('a');
            const file = new Blob([xml], {
                type: 'text/xml'
            });
            element.href = URL.createObjectURL(file);
            element.download = `${title ?? 'classIntegration'}.xml`;
            document.body.appendChild(element);
            element.click();
        };
        return <StyledDownloadButton onClick={downloadXML} variant='outlined'>{t('download')}</StyledDownloadButton>;
    };

    return (
        <XMLDiv>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{t('config-xml')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <DetailsDiv>
                        <TextField
                            multiline
                            rows={28}
                            value={xml}
                            disabled
                        />
                        <ButtonsDiv>
                            <CopyXMLButton/>
                            <DownloadButton/>
                        </ButtonsDiv>
                    </DetailsDiv>
                </AccordionDetails>
            </Accordion>
        </XMLDiv>
    );
};

export default XMLView;
